<template id="healthy-wager-cards">
    <div class="challenge-container">
        <h1 class="section-title">Join up to 10 challenges at once, or <a v-bind:href="selfServeLink">start your own challenge!</a></h1>
        <div v-if="isVisible">
            <div class="hwager-card">
                <a v-bind:href="nyopLink">
                    <div class="header">
                        <img :src="hwagerImage" alt="HealthyWager challenge image">
                        <h2 class="title">HealthyWager</h2>
                        <span class="tooltip" @click="toggleTooltip" @mouseover="showTooltip" @mouseleave="hideTooltip">
                          <i class="tooltip-nyop fa fa-question-circle" v-tooltip="tooltipOptions"></i>
                        </span>

                    </div>
                    <div class="content">
                        <div class="title">Make an individual weight loss bet & win</div>
                        <div class="prize"><span>Up to {{currency_sign}}10,000!</span></div>
                        <button class="calculate">Calculate My Prize</button>
                    </div>
                </a>
            </div>
        </div>

        <div class="company-challenge" v-if="showCompanyBtn">
            <a v-bind:href="corporateChallengeUrl">Looking for a company <br> challenge? Click Here</a>
            <button type="button" class="close" data-dismiss="modal" @click="removeCompanyBtn">&times;</button>
        </div>
    </div>
</template>

<script>
import { STATIC_URL } from './main';
import Globalized from '../shared/components/Globalized';

export default {
  template: '#healthy-wager-cards',
  props: ['corporateChallengeUrl', 'hwagerExclude'],
  mixins: [Globalized],
  data: function() {
    return {
      showCompanyBtn: true,
      nyopLink: window.location.origin + '/healthywager/',
      selfServeLink: window.location.origin + '/challenges/self-serve-challenges/',
      hwagerImage: `${STATIC_URL}img/healthy-wager/woman_running-minified.jpg`,
      currency_sign: this.site().moneySymbol(),
      tooltipOptions: {
        content: 'Create a personal weight loss goal and win cash prizes. Payout guaranteed if you reach your goal!',
        trigger: 'manual',
        show: false
      }
    }
  },
  computed: {
    isVisible: function() {
      return !this.hwagerExclude && this.$store.state.modalFilterValues.team !== 'team' && this.$store.state.modalFilterValues.type !== 'step'
    }
  },
  methods: {
    removeCompanyBtn: function() {
      this.showCompanyBtn = false;
    },
    toggleTooltip: function (event) {
      event.preventDefault();
      this.tooltipOptions.show = !this.tooltipOptions.show;
    },
    showTooltip: function () {
      this.tooltipOptions.show = true;
    },
    hideTooltip: function () {
      this.tooltipOptions.show = false;
    }
  }
}
</script>
